export const contactsData = {
    email: 'akashp73387@gmail.com',
    phone: '+91 7338714410',
    
  
}